// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerAlunos {
  height: 100%;
  margin-left: 1.9em;
  margin-right: 1.9em;
}

.topoAlunos {
  display: flex;
  margin-top: 1.5em;
  height: 6vh;
  justify-content: space-between;
  align-items: center;
}

.topoAlunos h1 {
  margin-left: 0.2em;
  width: 9vw;
  height: 7vh;
  font-size: 2em;
  font-family: "Roboto";
  font-weight: 400;
  color: var(--cor-pretoForte);
}

.cadastrarAluno {
  width: auto;
  height: 100%;
  border-radius: 8px;
  border: 1px var(--cor-roxoEscuro);
  background-color: var(--cor-roxoEscuro);
  font-size: 2.3vh;
  font-weight: 500;
  font-family: "Roboto";
  color: var(--cor-branco);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 1em;
  cursor: pointer;
}

.caixaBusca {
  height: 6vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2em;
  border-radius: 8px;
  background-color: var(--cor-roxoInput);
}

.iconAddAluno{
  height: 40%;
}

.inputBusca {
  width: 95%;
  height: 5vh;
  margin-right: 10px;
  border-radius: 8px;
  background-color: var(--cor-roxoInput);
  border: none;
  outline: none;
  padding-left: 25px;
}

.inputBusca:hover {
  background-color: var(--cor-roxoClaro);
}

.inputBusca::placeholder {
  font-family: "Roboto";
  font-weight: 400;
  font-size: 16px;
}

.buttonBuscar {
  margin-right: 20px;
  padding: 0;
  border: none;
  background-color: var(--cor-roxoInput);
  background-color: transparent;
  cursor: pointer;
  display: flex;
  border-radius: 80px;
}

.buttonBuscar:hover {
  background-color: var(--cor-roxoClaro);
}

.tabelaAlunos{
  margin-top: 1.5em;
  height: 72%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.status_emDia{
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: var(--cor-verde);
}

.status_emAtraso{
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: var(--cor-vermelho);
}
`, "",{"version":3,"sources":["webpack://./src/paginas/funcionario/Alunos.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC","sourcesContent":[".containerAlunos {\n  height: 100%;\n  margin-left: 1.9em;\n  margin-right: 1.9em;\n}\n\n.topoAlunos {\n  display: flex;\n  margin-top: 1.5em;\n  height: 6vh;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.topoAlunos h1 {\n  margin-left: 0.2em;\n  width: 9vw;\n  height: 7vh;\n  font-size: 2em;\n  font-family: \"Roboto\";\n  font-weight: 400;\n  color: var(--cor-pretoForte);\n}\n\n.cadastrarAluno {\n  width: auto;\n  height: 100%;\n  border-radius: 8px;\n  border: 1px var(--cor-roxoEscuro);\n  background-color: var(--cor-roxoEscuro);\n  font-size: 2.3vh;\n  font-weight: 500;\n  font-family: \"Roboto\";\n  color: var(--cor-branco);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 0 1em;\n  cursor: pointer;\n}\n\n.caixaBusca {\n  height: 6vh;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 2em;\n  border-radius: 8px;\n  background-color: var(--cor-roxoInput);\n}\n\n.iconAddAluno{\n  height: 40%;\n}\n\n.inputBusca {\n  width: 95%;\n  height: 5vh;\n  margin-right: 10px;\n  border-radius: 8px;\n  background-color: var(--cor-roxoInput);\n  border: none;\n  outline: none;\n  padding-left: 25px;\n}\n\n.inputBusca:hover {\n  background-color: var(--cor-roxoClaro);\n}\n\n.inputBusca::placeholder {\n  font-family: \"Roboto\";\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.buttonBuscar {\n  margin-right: 20px;\n  padding: 0;\n  border: none;\n  background-color: var(--cor-roxoInput);\n  background-color: transparent;\n  cursor: pointer;\n  display: flex;\n  border-radius: 80px;\n}\n\n.buttonBuscar:hover {\n  background-color: var(--cor-roxoClaro);\n}\n\n.tabelaAlunos{\n  margin-top: 1.5em;\n  height: 72%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.status_emDia{\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  background-color: var(--cor-verde);\n}\n\n.status_emAtraso{\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  background-color: var(--cor-vermelho);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
